<template>
  <div class="tw:bg-gray-100 tw:flex tw:flex-row tw:p-4 tw:rounded-2xl tw:justify-between tw:mb-4">
    <div class="tw:flex tw:items-center">
      <h3 class="tw:font-bold tw:mr-1">{{ $t(label) }}</h3>
      <UiTooltip :label="$t(tooltip)" tooltip-position="top" theme="customdarkwithpadding">
        <InformationOutline class="tw:fill-none tw:stroke-gray-500 tw:h-[19px] tw:w-[19px]" />
      </UiTooltip>
    </div>
    <p class="tw:text-[24px] tw:leading-[30px] tw:sm:text-header-big">
      {{ formatPercentage(language, value, 0, 0) }}
    </p>
  </div>
</template>
<script setup>
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'

import { formatPercentage } from '@/utils/Utility.ts'
import { useSessionValues } from '@/composables/useSessionValues'

const { language } = useSessionValues()
defineProps({
  label: String,
  tooltip: String,
  value: Number,
})
</script>
